import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      margin-left: -1px;\n      margin-right: -1px;\n    "])));
  },
  rootInline: function rootInline() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      margin-left: -0.0714285714285714em;\n      margin-right: -0.0714285714285714em;\n    "])));
  },
  icon: function icon() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      margin-bottom: -3px;\n      border-radius: 50%;\n      overflow: visible;\n    "])));
  },
  iconInline: function iconInline() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      height: 1.1428571428571428em;\n      width: 1.1428571428571428em;\n      margin-bottom: -0.2428571428571428em;\n      stroke-width: 0.10714285714285714em;\n    "])));
  }
});